export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false,
    role: null,
    userRole: 'guest',
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData;
      state.isAuthenticated = !!userData;
      state.role = userData?.role || 0; // 0 là Guest
      state.userRole = userData?.role === 1 ? "admin" : userData?.role === 2 ? "manager" : userData?.role === 3 ? "customer" : "guest";
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.role = 0; // Guest khi đăng xuất
    },
  },
  actions: {
	async fetchUser({ commit }) {
		try {
			console.log("🔄 Fetching user...");

			// Gọi API lấy thông tin người dùng với Cookie
			const response = await fetch("/api/user", {
				method: "GET",
				credentials: "include", // Bắt buộc để gửi HttpOnly Cookie
				headers: { "Accept": "application/json" }
			});

			if (response.status === 401) {
				console.warn("⚠️ User chưa đăng nhập");
				commit("setUser", null);
				return;
			}

			if (!response.ok) {
				const errorData = await response.json();
				console.error("❌ Lỗi từ server:", errorData);
				throw new Error(errorData.message || "Không thể lấy thông tin người dùng");
			}

			const userData = await response.json();
			commit("setUser", userData);
		} catch (error) {
			console.error("❌ Lỗi fetchUser:", error.message);
			commit("setUser", null);
		}
	},
	async loginUser({ commit }, userData) {
      commit("setUser", userData); // Cập nhật trạng thái user khi đăng nhập thành công
    },

    async logoutUser({ commit }) {
		console.log('logoutUser');
		try {
			const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

			const response = await fetch("/api/logout", {
				method: "POST",
				credentials: "include",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
					"X-CSRF-TOKEN": csrfToken, // Gửi CSRF token
				},
			});

			if (!response.ok) throw new Error("Đăng xuất thất bại");

			// commit("logout"); // Xóa state Vuex
			window.location.href = "/"; // Load lại trang về trang chủ
		} catch (error) {
			console.error("Lỗi logoutUser:", error);
		}
	}
  },
  getters: {
    isAdmin: (state) => state.role === 1,
    isManager: (state) => state.role === 2,
    isUser: (state) => state.role === 2,
    isGuest: (state) => state.role === 0,
  },
};
